module.exports = __webpack_public_path__ + "img/glry-6.26ae4581.jpg";